<template>
  <div>
    <!-- INFOS DO USUÁRIO -->
    <v-dialog
      dark
      persistent
      width="700px"
      transition="dialog-bottom-transition"
      v-model="dialogUser">
      <v-card>
        <v-card-title class="pa-3">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-tabs-items v-model="tab" dark>
            <!-- info -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-form lazy-validation ref="formUser" v-model="validFormUser">
                    <v-row>
                      <v-col cols="12" class="text-center pt-0">
                        <v-avatar size="128" @click="openFile()" class="file-user">
                          <img
                            v-if="formUser.photo"
                            :src="formUser.photo"
                            :alt="formUser.name"
                            :loading="formUser" />
                          <img
                            :loading="!!me"
                            v-else
                            src="@/assets/images/no-photo.jpg"
                            :alt="formUser.name" />
                          <div class="overlay d-flex justify-center align-center">
                            <v-icon>mdi-camera</v-icon>
                          </div>
                        </v-avatar>

                        <v-file-input
                          id="inputFileHeader"
                          style="display: none"
                          v-model="file"></v-file-input>
                      </v-col>

                      <v-col cols="12" class="pb-0">
                        <v-text-field
                          label="Nome"
                          color="yellow"
                          :rules="[(v) => !!v || 'O nome é obrigatório']"
                          v-model="formUser.name"></v-text-field>
                      </v-col>

                      <v-col cols="12" class="pb-0">
                        <v-text-field
                          label="E-Mail"
                          color="yellow"
                          :rules="[(v) => !!v || 'O e-mail é obrigatório']"
                          v-model="formUser.email"></v-text-field>
                      </v-col>

                      <v-col cols="12" class="d-flex">
                        <v-btn text @click="changeTab(1)">Alterar senha</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="yellow" text @click="updateUser">Salvar</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- senha -->
            <v-tab-item>
              <ChangePasswordForm
                :error4017="error4017"
                @submit="changePassword"
                @cancel="changeTab(0)" />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- CROPPER DE IMAGEM -->
    <v-dialog dark persistent width="500" v-model="dialogCropper">
      <v-card>
        <v-card-text class="pa-0">
          <div style="width: 500px; height: 500px; overflow: hidden">
            <cropper
              style="height: 100%; width: 100%"
              :src="img"
              @change="change"
              :auto-zoom="false"
              image-restriction="stencil"
              :stencil-props="{
                previewClass: 'preview',
              }"
              stencil-component="circle-stencil" />
          </div>
          <v-btn depressed class="rounded-0" style="width: 50%" @click="dialogCropper = false"
            >Cancelar</v-btn
          >
          <v-btn depressed class="rounded-0" style="width: 50%" @click="changeImg()">Salvar</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { PASSWORD_REUSED_MESSAGE } from "@/utils/password";
import ChangePasswordForm from "../ChangePasswordForm.vue";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
import { updateUserMe } from "@/services/me";
import { postFile, uploadAWS } from "@/services/file";
import { changePassword, updateProfilePhoto } from "@/services/user";

export default defineComponent({
  name: "UserDialog",
  components: {
    ChangePasswordForm,
    Cropper,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    me: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "cancel", "snackbar", "me-updated"],
  data() {
    return {
      dialogCropper: false,
      img: "",
      tempImg: "",
      changeFile: false,
      file: null as File | null,

      savingUser: false,
      validFormUser: false,
      userPhoto: null,
      tab: 0,
      error4017: false,
      formUser: {
        name: "",
        email: "",
        photo: "",
        old_password: "",
        new_password: "",
        _2fa: false,
      },
    };
  },
  computed: {
    dialogUser: {
      get(): boolean {
        return this.dialog;
      },
      set(value: boolean) {
        if (!value) this.$emit("close");
      },
    },
  },
  watch: {
    dialog(val: boolean) {
      if (val) this.initializeFormUser();
    },
    file() {
      if (this.changeFile) {
        this.changeFile = false;
        return;
      }
      if (this.file) {
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = () => {
          if (typeof reader.result === "string") {
            this.img = reader.result;
            this.dialogCropper = true;
            const inputFile = document.getElementById("inputFileHeader") as HTMLInputElement;
            if (inputFile) inputFile.value = "";
          }
        };
      }
    },
  },
  methods: {
    change({ canvas }: any): void {
      this.tempImg = canvas.toDataURL();
    },

    changeImg(): void {
      this.changeFile = true;
      this.formUser.photo = this.tempImg;
      this.file = this.dataURLtoFile(this.tempImg);
      this.dialogCropper = false;
    },

    dataURLtoFile(dataurl: string): File {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)?.[1] ?? "image/png";
      const bstr = atob(arr[1]);
      const u8arr = new Uint8Array(bstr.length);
      for (let i = 0; i < bstr.length; i++) u8arr[i] = bstr.charCodeAt(i);

      const fileName = this.file?.name || "photo.png";
      return new File([u8arr], fileName, { type: mime });
    },

    openFile(): void {
      document.getElementById("inputFileHeader")?.click();
    },

    initializeFormUser(): void {
      this.formUser.name = this.me.name;
      this.formUser.email = this.me.email;
      this.formUser.photo = this.me.profile_photo?.url || "";
      this.formUser._2fa = !!this.me._2fa;
    },

    async changePassword(data: { old: string; new: string }): Promise<void> {
      if (this.savingUser) return;

      const payload = {
        new_password: data.new,
        password: data.old,
      };

      this.savingUser = true;

      try {
        await changePassword(payload);
        this.$emit("snackbar", { message: "Senha alterada com sucesso!" });
        this.error4017 = false;
        this.dialogUser = false;
      } catch (err: any) {
        const error4017 = err?.response?.data?.errors?.find((e: any) => e.code === 4017);
        this.error4017 = !!error4017;

        this.$emit("snackbar", {
          message: error4017 ? PASSWORD_REUSED_MESSAGE : "Não foi possível alterar a senha",
        });
      } finally {
        this.savingUser = false;
      }
    },

    async updateUser(): Promise<void> {
      const userMePayload = {
        ...this.me,
        name: this.formUser.name,
        email: this.formUser.email,
        _2fa: this.formUser._2fa ? "TOTP" : null,
        roles: this.me.roles.map((r: any) => r.id),
        password_due_date: this.me.password_due_date === "None" ? null : this.me.password_due_date,
      };

      try {
        const res: any = await updateUserMe(userMePayload);

        this.$emit("me-updated", { name: res.data.name, email: res.data.email, _2fa: res.data._2fa });

        if (this.file) {
          const payloadFile = {
            folders: ["profile", "photo"],
            original_name: this.file.name,
            content_type: this.file.type,
            size: this.file.size,
          };

          try {
            const fileAWS = await postFile(payloadFile);

            const formData = new FormData();
            Object.entries(fileAWS.data._storage.fields).forEach(([key, value]) => {
              formData.append(key, value as string);
            });
            formData.append("file", this.file);
            formData.append("Content-Type", fileAWS.data.content_type);

            await uploadAWS(fileAWS.data._storage.url, formData);
            this.$emit("me-updated", { profile_photo: { url: fileAWS.data.url } });
            await updateProfilePhoto({ profile_photo_id: fileAWS.data.id });
          } catch (uploadErr) {
            console.warn("Erro ao enviar a imagem:", uploadErr);
          }
        }

        this.$emit("snackbar", { message: "Usuário alterado com sucesso!" });
      } catch (err) {
        console.warn("Erro ao atualizar usuário:", err);
        this.$emit("snackbar", { message: "Erro ao alterar usuário!" });
      }

      this.dialogUser = false;
    },

    changeTab(tab: number): void {
      this.tab = tab;
    },

    handleCancel(): void {
      this.$emit("cancel");
    },

    handleClose(): void {
      this.$emit("close");
    },
  },
});
</script>
<style lang="scss" scoped>
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  background-color: rgba(0, 0, 0, 0.3);
}
.overlay:hover {
  opacity: 1;
}
</style>
